import { useTranslation } from "react-i18next";
import * as yup from "yup";

export const appl108ValidationSchema = () => {
  const { t } = useTranslation();
  return yup.object().shape({
    domesticBranchGemiNumber: yup
      .object()
      .required(t("Το πεδίο είναι υποχρεωτικό")),
    docPraktFileDate: yup
      .date()
      .nullable()
      .typeError(t("Το πεδίο πρέπει να είναι ημερομηνία"))
      .min(
        new Date(1900, 0, 1),
        t("Η ημερομηνία δεν μπορεί να είναι πριν από 01/01/1900"),
      )
      .max(
        new Date(9999, 11, 31),
        t("Η ημερομηνία δεν μπορεί να είναι πριν από 31/12/9999"),
      ),
    fudocDoyBranch: yup.string().required(t("Το πεδίο είναι υποχρεωτικό")),
    coDateStart: yup
      .date()
      .typeError(t("Το πεδίο πρέπει να είναι ημερομηνία"))
      .required(t("Το πεδίο είναι υποχρεωτικό"))
      .min(
        new Date(1900, 0, 1),
        t("Η ημερομηνία δεν μπορεί να είναι πριν από 01/01/1900"),
      )
      .max(
        new Date(9999, 11, 31),
        t("Η ημερομηνία δεν μπορεί να είναι πριν από 31/12/9999"),
      ),
    primaryKad: yup.object().required(t("Το πεδίο είναι υποχρεωτικό")),
  });
};
